import { IComponentOptions } from "angular";
import { GtmhubController } from "@gtmhub/core";

export class PostCommentWithAvatarsComponentCtrl extends GtmhubController {}

export const PostCommentWithAvatarsComponent: IComponentOptions = {
  bindings: {
    action: "&",
    commentsCount: "<",
    userIds: "<",
    avatarPreviewNumber: "<",
  },
  controller: PostCommentWithAvatarsComponentCtrl,
  templateUrl: require("./post-comment-with-avatars.jade"),
};
